import React, { createRef } from "react";
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import 'swiper/components/pagination/pagination.less'
import { LazyLoadImage } from 'react-lazy-load-image-component';

import utils from "../../utils/utils";
import "./style.less";
class RecommendSwiper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    }
    this.swiperRef = createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      this.initSwiper();
    }, 800)
  }
  initSwiper() {
    // 轮播组件初始化
    this.swiper = new Swiper(this.swiperRef.current, {
      spaceBetween: 0,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
      },
    });
    // this.swiper.on('slideChange', () => {
    //   this.handleSlideChange(this.swiper)
    // });
    // this.handleSlideChange({ realIndex: 0 });
  }

  handleItemClick = (index) => {
    const jumpLink = this.props.config.itemList[index].link;
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: jumpLink,
        props: this.props,
        index
      })
      return
    }

    const options = {
      link: jumpLink,
      sort: index,
    };
    const convertUrl = utils.convertHref(jumpLink);
    utils.jumpToUrl(this.props.routeParams, convertUrl, jumpLink, options, -1, this.props, false);
  }

  handleSlideChange = (swiper) => {
    const activeIndex = swiper.realIndex;
    this.setState({
      activeIndex,
    });
  }

  slideClick = (clickIndex) => {
    this.setState({
      activeIndex: clickIndex,
    });
    if (clickIndex === this.state.activeIndex) {
      this.handleItemClick(clickIndex);
    }
  }

  render() {
    const { categoryCard = {}, categoryCardRecommendIcon, categoryRecommend, categoryName, categoryCardBgImage } = this.props;
    const { imgList = [], title } = categoryCard;
    // const { imgBottomUrl } = currentBg;
    // console.log('item==this.props==imgList', this.props, imgList);

    return (
      <div className="main-top-left-single">
        <div className="main-top-left-item">

          <div className="main-top-left-item-bg">
            <LazyLoadImage
              width="100%"
              threshold={500}
              height="100%"
              src={categoryCardBgImage}
              effect="opacity"
            />
          </div>
          <div className="swiper-container-child" ref={this.swiperRef}>
            <div className="swiper-wrapper">
              {imgList && imgList.map((categoryCardItem, categoryCardIndex) => {
                const { image, link } = categoryCardItem;
                return <div className="swiper-slide" key={categoryCardIndex}>
                  <img className="pro-item-img" src={image} onClick={() => {
                    const options = {
                      sort: categoryCardIndex,
                      tabChName: title,
                      floor_name: categoryName
                    }
                    utils.jumpToUrl(this.props.routeParams, link, link, options, -1, { ...this.props, ...options }, false, { bizExtra: { model_block: 'zone',floor_name: categoryName }, categoryName });
                  }} />
                </div>
              })}
            </div>
          </div>
          <div className="pro-item-three" style={{
            // bottom: utils.isAndroid() ? '22px':'20px'
          }}>
            <p className="pro-item-three-title">{title}</p>
          </div>
          {categoryCardRecommendIcon && <img className="pro-item-top-icon" src={categoryCardRecommendIcon}/>}
        </div>

        <div className="btn">{categoryRecommend}</div>
      </div>

    );
  }
}

export default RecommendSwiper;



// WEBPACK FOOTER //
// ./components/pipeline-sence-swiper/recommendSwiper.js